import { create } from "zustand";

type RosterFocusState = {
  hoveredColumn: string | null;
  selectedColumn: string | null;
  hoveredNurseId: string | null;
  selectedNurseId: string | null;
  isSelectedFocusPinned: boolean;
  setHoveredFocus: (payload: { column: string; nurseId: string }) => void;
  clearHoveredFocus: () => void;
  setSelectedFocus: (payload: {
    column: string;
    nurseId: string;
    retainOnOutsideClick?: boolean;
  }) => void;
  clearSelectedFocus: () => void;
};

export const useRosterFocusStore = create<RosterFocusState>((set) => ({
  hoveredColumn: null,
  selectedColumn: null,
  hoveredNurseId: null,
  selectedNurseId: null,
  isSelectedFocusPinned: false,
  setHoveredFocus: ({ column, nurseId }) =>
    set({ hoveredColumn: column, hoveredNurseId: nurseId }),
  clearHoveredFocus: () => set({ hoveredColumn: null, hoveredNurseId: null }),
  setSelectedFocus: ({ column, nurseId, retainOnOutsideClick = false }) =>
    set({
      selectedColumn: column,
      selectedNurseId: nurseId,
      isSelectedFocusPinned: retainOnOutsideClick,
    }),
  clearSelectedFocus: () =>
    set({
      selectedColumn: null,
      selectedNurseId: null,
      isSelectedFocusPinned: false,
    }),
}));
